<template><div><h1 id="auswertungen-organisation" tabindex="-1"><a class="header-anchor" href="#auswertungen-organisation"><span>Auswertungen Organisation</span></a></h1>
<p>Die Referenz beschreibt Auswertungen und Statistiken aus dem Bereich Organisation.</p>
<p><strong>Inhaltsverzeichnis</strong></p>
<p><RouteLink to="/referenz/refstat/ft.refstat.ConcurrentUsers.html">Concurrent Users</RouteLink> - Listet die Anzahl angemeldeter Benutzer pro Tag auf</p>
<p><RouteLink to="/referenz/refstat/ft.refstat.esrfehlerliste.html">ESR Fehlerliste mutiert nach User</RouteLink> - Listet die Anzahl mutierten fehlerhaften Buchungen</p>
<p><RouteLink to="/referenz/refstat/ft.refstat.monitoring.html">Monitoring</RouteLink> - Berichte über definietre Vorgänge um Abweichungen vom Normalbetrieb festzustellen</p>
</div></template>


